/**
 * @file validation.service.js
 * @module ValidationService
 * @description Service for validating reservation form fields.
 */

/** * Validate the 'from' address.
 * @param {object} from - The 'from' address object.
 * @returns {string} - The validation message.
 */
export function fromValidationMessage(from) {
    if (from.$error) {
        if (!from.required) {
            return "Enter address From";
        }
        return "Enter address From";
    }
    return "";
}

/** * Validate the 'to' address.
 * @param {object} to - The 'to' address object.
 * @returns {string} - The validation message.
 */
export function toValidationMessage(to) {
    if (to.$error) {
        if (!to.required) {
            return "Enter address To";
        } else if (!to.differentFromPickup) {
            return "From and To must be different so the ride has a valid route";
        }
        return "Enter address To";
    }
    return "";
}

/** * Validate the deal number.
 * @param {object} dealNumber - The deal number object.
 * @returns {string} - The validation message.
 */
export function dealNumberValidationMessage(dealNumber) {
    if (!dealNumber.$error) return "";

    if (!dealNumber.maxLength) {
        return `Maximum ${dealNumber.$params.maxLength.max}  characters.`;
    }

    if (!dealNumber.customValidator) {
        return "Enter alphanumeric code: XXX-99999";
    }
    return "";
}

/** * Validate the passengers count.
 * @param {object} passengersCount - The passengers count object.
 * @returns {string} - The validation message.
 */
export function passengerCountValidationMessage(passengersCount) {
    if (!passengersCount.$error) return "";

    if (!passengersCount.required) {
        return `Enter a PAX N°`;
    }

    if (!passengersCount.numeric || !passengersCount.integer) {
        return "Enter a whole number";
    }

    if (!passengersCount.maxValue) {
        return `PAX N° cannot exceed ${passengersCount.$params.maxValue.max}`;
    }

    if (!passengersCount.customValidator) {
        return "Doesn't match the PAX list";
    }

    return `Enter a PAX N°`;
}

/** * Validate the child seats count.
 * @param {object} childSeatsCount - The child seats count object.
 * @returns {string} - The validation message.
 */
export function childSeatsCountValidationMessage(childSeatsCount) {
    if (!childSeatsCount.$error) return "";

    if (!childSeatsCount.numeric || !childSeatsCount.integer) {
        return "Enter a whole number";
    }

    if (!childSeatsCount.maxValue) {
        return `Maximum of ${childSeatsCount.$params.maxValue.max} child seats allowed`;
    }

    return `Enter a child seat count`;
}